var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284053",
    "data-name": "Pfad 284053",
    d: "M31,28.925a3.075,3.075,0,0,0-2.553,1.364l-7.441-4.65a2.993,2.993,0,0,0,0-1.278l7.441-4.65a3.1,3.1,0,1,0-.453-1.072l-7.441,4.65a3.075,3.075,0,1,0,0,3.422l7.441,4.65A3.074,3.074,0,1,0,31,28.925Zm0-12.85A1.925,1.925,0,1,1,29.075,18,1.926,1.926,0,0,1,31,16.075ZM18,26.925A1.925,1.925,0,1,1,19.925,25,1.926,1.926,0,0,1,18,26.925Zm13,7A1.925,1.925,0,1,1,32.925,32,1.926,1.926,0,0,1,31,33.925Z",
    transform: "translate(-13 -13)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19272",
    "data-name": "Gruppe 19272",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24682",
    "data-name": "Rechteck 24682",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c4450e07c80e61354d4e2fab9e250da6.svg";
export { ForwardRef as ReactComponent };